import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store.model';

export function getFeatureToggle(state: RootState) {
  return state.featureToggle;
}

const getApplicationsListFeatureToggle = (state: RootState) =>
  getFeatureToggle(state).applicationsList;
const getApplicationFeatureToggle = (state: RootState) =>
  getFeatureToggle(state).applicationDefault ?? 'devicemanager';

export const getApplicationsFeatureToggle = createSelector(
  [getApplicationsListFeatureToggle],
  (applicationsListString) =>
    applicationsListString?.split(',') ?? ['devicemanager']
);

export const getDefaultApplicationFeatureToggle = createSelector(
  [getApplicationFeatureToggle, getApplicationsFeatureToggle],
  (defaultApplication) => {
    return defaultApplication ?? 'devicemanager';
  }
);
